<template>
  <b-card no-body class="card-developer-meetup">
    <router-link
      :to="
        $route.params.id
          ? {
              name: 'ngo_details_donation',
              params: { id: item.id, details_donation_id: $route.params.id },
            }
          : { name: 'details_donation', params: { id: item.id } }
      "
    >
      <div class="bg-primary text-center p-1 text-white rounded-top">
        منظمة {{ item.ngo.name_ar }}
      </div>
    </router-link>

    <div>
      <img
        style="object-fit: cover"
        :src="item.image"
        height="200"
        width="100%"
      />
    </div>
    <div class="pt-2 px-2">
      <div>
        <h5 class="text-center title_name">{{ item.name_ar }}</h5>
      </div>

      <div class="font-weight-bold my-2">
        <div v-if="item.is_active" class="text-secondary">
          <img :src="require('@/assets/global/time.png')" width="20" />
          انتهاء الحملة بعد {{ item.remaining_time }} يوم
        </div>
        <div v-else class="text-secondary">
          <img :src="require('@/assets/global/time.png')" width="20" />
          حملة منتهية
        </div>
      </div>

      <div class="d-flex justify-content-around">
        <div class="text-center">
          <div>نوع التبرع</div>
          <div class="font-small-4 font-weight-bold mt-1">
            {{ item.campaign_type ? "مادي" : "عيني" }}
          </div>
        </div>
        <div class="vline"></div>
        <div class="text-center">
          <div>تستهدف</div>
          <ul class="font-small-4 font-weight-bold list_cat">
            <li v-if="item.ageCategories" class="list_style_disc">
              {{ item.ageCategories[0] ? item.ageCategories[0].name_ar : "" }}
            </li>
          </ul>
        </div>
        <div class="vline"></div>

        <div class="text-center">
          <div>عدد المتبرعين</div>
          <span class="font-large-1 font-weight-bold">{{
            item.donors_numbers
          }}</span>
        </div>
      </div>
      <hr />
    </div>

    <div
      class="font-weight-bold text-center progress_nomber"
      v-if="
        percentageCalculator(
          item.remaining_amount,
          item.campaign_type ? item.campaign_amount.replace(/,/g, '') : item.count
        ) < 5
      "
    >
      {{
        "(" +
        percentageCalculator(
          item.remaining_amount,
          item.campaign_type ? item.campaign_amount.replace(/,/g, '') : item.count
        ) +
        "%)"
      }}
    </div>
    <div class="mx-1">
      <b-progress
        :class="{
          isActive:
            percentageCalculator(
              item.remaining_amount,
              item.campaign_type ? item.campaign_amount.replace(/,/g, '') : item.count
            ) >= 5,
        }"
        max="100"
        class="progress-bar-secondary donationProgress mb-2"
      >
        <b-progress-bar
          :value="`${percentageCalculator(
            item.remaining_amount,
            item.campaign_type ? item.campaign_amount.replace(/,/g, '') : item.count
          )}`"
          :label="`${
            percentageCalculator(
              item.remaining_amount,
              item.campaign_type ? item.campaign_amount.replace(/,/g, '') : item.count
            ) >= 5
              ? '(' +
                percentageCalculator(
                  item.remaining_amount,
                  item.campaign_type ? item.campaign_amount.replace(/,/g, '') : item.count
                ) +
                '%)'
              : ''
          }`"
          variant="info"
        />
      </b-progress>

      <div class="d-flex justify-content-around pb-1">
        <div class="text-center">
          <div class="mb-1">تم التبرع بـ</div>
          <span class="h2 font-weight-bold text-success">
            {{
              item.campaign_type
                ? (item.campaign_amount.replace(/,/g, '') - item.remaining_amount).toLocaleString(
                    "en-US"
                  )
                : item.count - item.remaining_amount
            }} </span
          ><span v-if="item.campaign_type" class="text-success">ل.س</span>
        </div>

        <div class="text-center">
          <div class="mb-1">
            {{ item.campaign_type ? "المبلغ المتبقي" : "العدد المتبقي" }}
          </div>
          <span class="h2 font-weight-bold text-danger">
            {{
              item.campaign_type
                ? item.remaining_amount.toLocaleString("en-US")
                : item.remaining_amount
            }}
          </span>
          <span v-if="item.campaign_type" class="text-danger">ل.س</span>
        </div>
      </div>
    </div>
    <router-link
      :to="
        $route.params.id
          ? {
              name: 'ngo_details_donation',
              params: { id: item.id, details_donation_id: $route.params.id },
            }
          : { name: 'details_donation', params: { id: item.id } }
      "
    >
      <b-button block variant="primary"> التفاصيل </b-button>
    </router-link>
  </b-card>
</template>
<script>
import { BCard, BButton, BProgress, BProgressBar } from "bootstrap-vue";
export default {
  props: ["item"],
  components: {
    BCard,
    BButton,
    BProgress,
    BProgressBar,
  },
  data() {
    return {};
  },

  methods: {
    percentageCalculator(remaining_amount, campaign_amount) {
      return parseInt(
        ((campaign_amount - remaining_amount) / campaign_amount) * 100
      );
    },
  },
};
</script>

<style lang="scss">
.donationProgress {
  height: 15px;
  .progress-bar {
    position: static;
    height: 15px;
    background-color: #048042 !important;
  }
}
.list_cat {
  margin-top: 9px;
  height: 40px;
}
.title_name {
  font-size: 20px;
}
.vline {
  border-left: 1px solid #ccc;
  height: 55px;
}

.isActive {
  margin-top: 20px;
}
.progress_nomber {
  position: relative;
  bottom: -18px;
}
</style>
